import { render, staticRenderFns } from "./pr-list.vue?vue&type=template&id=12c44937&"
import script from "./pr-list.vue?vue&type=script&lang=js&"
export * from "./pr-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports